export default "__VITE_ASSET__SrzbYP8VFbfrjPW0RDTHHg__"